import React from "react"
import LinkButton from "@components/common/LinkButton"
import { ArrowRight } from "@phosphor-icons/react"

import { MockDiscover } from "../../mockdata/mockdata"
import TallCard from "../productcards/TallCard"

const DiscoverSection = ({data}) => {

  return (
    <React.Fragment>
      <section className="max-container mt-14">
        <section className="flex flex-wrap justify-between items-start gap-x-6 flex-col md:flex-row">
          <div>
            <h1>Discover Your Style</h1>
            <p className="mb-4">
              Find your perfect swimwear with our range of styles to suit every taste.
            </p>
          </div>

          {/* <LinkButton
            label={"Explore categories"}
            className={'underline-on-hover'}
            icon={<ArrowRight size={20} weight="light" />}
          /> */}
        </section>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-4 xl:gap-8 mt-6 md:mt-0">
          {
            MockDiscover.map((item, index) => {
              return (
                <TallCard
                  data={item}
                  cardStyles={"discover-container"}
                  key={`discover-item-${index}`}
                />
              );
            })
          }
        </div>
      </section>
    </React.Fragment>
  );
}

export default DiscoverSection